import { mergeUser, setRegistry } from 'registry/actions'
import { destroyState } from 'lib/session-storage'
import { pick } from 'lodash'
import {
  getFBCCookie,
  getFBPCookie,
  getRedditClickIdCookie,
  getRedditUUIDCookie,
  track,
  userEventProps,
} from 'lib/analytics'
import {
  getApprovedProductRecommendations,
  getInitialRegItems,
  getPartner,
  getRegistry,
  getUser,
  getUserFields,
} from '../reducers'
import * as api from '../api'

export {
  setArrivalDate,
  setIsArrivalDateKnown,
  setPlanningStage,
} from 'registry/actions'

export const signup = (data, trackingData = {}) => {
  return (dispatch, getState) => {
    const state = getState()
    const reduxUserData = getUser(state)
    const registry = getRegistry(state)
    const onboardingUserData = getUserFields(state)
    const initialRegItems = getInitialRegItems(state)

    if (
      trackingData.userAuthenticationMethod ===
      track.UserAuthenticationMethod.EMAIL
    ) {
      track.signUpStepProcessed({
        eventLocation: track.EventLocation.SIGN_UP_MINUS_START,
        userAuthenticationMethod: track.UserAuthenticationMethod.EMAIL,
      })
    }

    return api
      .signup({
        registry,
        user: {
          ...reduxUserData,
          ...data.formData,
          onboarding: onboardingUserData,
        },
        recaptcha_token: data.recaptchaToken,
        initialRegItems,
      })
      .then((resp) => {
        // signupCompleted takes a special `userId_` property for use in
        // the analytics.identify process.
        // https://www.avo.app/docs/workspace/tracking-plan#a-nameidentify-usera-identify-user
        // move this
        try {
          track.signUpSubmitted({
            eventLocation: track.EventLocation.SIGN_UP_MINUS_START,
            eventType: track.EventType.SUCCESSFUL,
            userAuthenticationMethod: track.UserAuthenticationMethod.EMAIL,
          })
          track.signUpCompleted({
            ...userEventProps(resp.user),
            capiEventId: `registryCreated:${resp.user?.currentRegistry?.id}`,
            email: resp.user?.email,
            eventLocation: trackingData.eventLocation,
            userId: resp.user?.id,
            registryId: resp.user?.currentRegistry?.id,
            userAuthenticationMethod: trackingData.userAuthenticationMethod,
            userFirstName: data.formData?.firstName,
            userLastName: data.formData?.lastName,
            facebookClickId: getFBCCookie(),
            facebookPixelId: getFBPCookie(),
            redditClickId: getRedditClickIdCookie(),
            redditUuid: getRedditUUIDCookie(),
          })
          track.listCreated({
            ...userEventProps(resp.user),
            listType: track.ListType.BABY_REGISTRY,
            eventLocation: track.EventLocation.ACCOUNT_CREATION_FORM,
            registryId: resp.user?.currentRegistry?.id,
            registryOwnerId: resp.user?.id,
          })
        } catch (e) {
          console.log('tracking error', e)
        }
        dispatch(setRegistry(resp.registry))
        dispatch(mergeUser(resp.user))
        return resp
      })
      .then((resp) => {
        const state = getState()
        const products = getApprovedProductRecommendations(state)

        if (products.length > 0) {
          api.addProductsToRegistry(resp.registry.id, products)
        }
        return resp
      })
      .then((resp) => {
        destroyState()
        return resp
      })
      .catch((errors) => Promise.reject(errors))
  }
}

export const saveHasPartner = (hasPartner) => {
  return (dispatch, getState) => {
    const state = getState()
    const registry = getRegistry(state)
    return api
      .saveHasPartner({ registry, hasPartner })
      .then(({ registry }) => {
        dispatch(setRegistry(registry))
      })
      .catch((errors) => Promise.reject(errors))
  }
}

export const addPartner = (partnerData) => {
  return (dispatch, getState) => {
    const state = getState()
    const registry = getRegistry(state)
    const partner = { ...getPartner(state), ...partnerData }
    return api
      .addPartner({ registry, partner })
      .then(({ registry }) => {
        dispatch(setRegistry(registry))
      })
      .catch((errors) => Promise.reject(errors))
  }
}

export const invitePartnerAsCollaborator = ({ email }) => {
  return (dispatch, getState) => {
    const state = getState()
    const registry = getRegistry(state)
    const partner = { ...getPartner(state), email }

    return api
      .convertPartnerToCollaborator({ registry, partner })
      .then(({ registry }) => {
        dispatch(setRegistry(registry))
      })
      .catch((errors) => Promise.reject(errors))
  }
}

export const saveOnboardingData = () => {
  return (dispatch, getState) => {
    const state = getState()
    const onboarding = getUserFields(state)

    return api
      .saveUser({ onboarding })
      .then(({ user }) => {
        dispatch(mergeUser(user))
      })
      .catch((errors) => Promise.reject(errors))
  }
}

export const SET_USER_RESPONSE = 'SET_USER_RESPONSE'
export const setUserResponse = (data) => ({ type: SET_USER_RESPONSE, data })

export const SET_INITIAL_REG_ITEMS = 'SET_INITIAL_REG_ITEMS'
export const setInitialRegItems = (initialRegItems) => ({
  type: SET_INITIAL_REG_ITEMS,
  initialRegItems,
})

export const SET_APPROVED_PRODUCT_RECOMMENDATION =
  'SET_APPROVED_PRODUCT_RECOMMENDATION'
export const setApprovedProductRecommendations = (approvedProductList) => ({
  type: SET_APPROVED_PRODUCT_RECOMMENDATION,
  approvedProductList,
})
